import e from "./highrise1340.mjs";
import m from "./highrise1341.mjs";
import n from "./highrise1342.mjs";
function h(a) {
  var t = m(a);
  return t.length == 1 && t[0][2] ? n(t[0][0], t[0][1]) : function(r) {
    return r === a || e(r, a, t);
  };
}
export {
  h as default
};
